import { Message } from 'element-ui'
const directive = {


  // 一键复制
  copy: {
    bind(el, { value }) {
      el.$value = value;
      el.handler = async () => {
        if (!el.$value) {
          Message.info('没有要复制的内容')
          return
        }
        try {
          await navigator.clipboard.writeText(el.$value);
          Message.success('复制成功')
        } catch (err) {
          Message.error('复制失败')
        }
      }
      el.addEventListener('click', el.handler)
    },
    componentUpdated(el, { value }) {
      el.$value = value;
    },
    unbind(el) {
      el.removeEventListener('click', el.handler)
    }
  }
}

export default directive;